/**
 * Push Node Component
 *
 * Sends push notifications to users.
 * Receives title and body from upstream Prompt node.
 */

import { memo } from 'react';
import { type NodeProps } from '@xyflow/react';
import { BaseNode } from './BaseNode';
import type { NodeData, PushTargetType } from '@/types/imageWorkflow';

const TARGET_TYPE_LABELS: Record<PushTargetType, string> = {
  follow_start: '跟随启动',
  current_user: '当前用户',
  all_users: '所有用户',
  specific_users: '指定用户',
};

const PushNodeComponent = ({ id, data, selected }: NodeProps) => {
  const nodeData = data as NodeData;
  const targetType = (nodeData.push_target_type || 'follow_start') as PushTargetType;
  const targetUserIds = nodeData.push_target_user_ids || [];

  return (
    <BaseNode id={id} data={nodeData} type="push" selected={selected} hasSourceHandle={false}>
      <div className="space-y-1">
        {/* Target Type */}
        <div className="flex items-center gap-2">
          <span className="text-purple-500">目标:</span>
          <span className="text-purple-700 font-medium">
            {TARGET_TYPE_LABELS[targetType]}
          </span>
        </div>

        {/* User count for specific_users */}
        {targetType === 'specific_users' && targetUserIds.length > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-gray-500">用户数:</span>
            <span className="text-gray-700">{targetUserIds.length} 人</span>
          </div>
        )}

        {/* Sound setting */}
        {nodeData.push_sound && nodeData.push_sound !== 'default' && (
          <div className="flex items-center gap-2">
            <span className="text-gray-500">声音:</span>
            <span className="text-gray-700">{nodeData.push_sound}</span>
          </div>
        )}

        {/* Input hint */}
        <div className="text-xs text-gray-400 mt-1">
          ← 接收 Prompt 节点输出
        </div>
      </div>
    </BaseNode>
  );
};

export const PushNode = memo(PushNodeComponent);
export default PushNode;
